import BaseBehavior from '../../../framework/base/base';
import { itemSlider } from './item-slider';
import { screenGreatOrEqualTo } from '../../../shared/utilities/screenSize';
import { dashCaseToCamelCase } from '../../../shared/utilities/case';

export default class OnPageNav extends BaseBehavior {
	constructor(element) {
		super(element);
		// don't run behavior for markup intended for dekstop and vice-&-versa.
		if (window.getComputedStyle(this.element).getPropertyValue('display') === 'none') return;
		this.isDesktop = screenGreatOrEqualTo('sm');
		this.initDomCache();
		// on page nav is a slider on desktop.
		if (this.isDesktop) {
			this.setWidthsToElements();
			this.itemSlider = itemSlider(element.querySelector('.v2-item-slider'), {
				isOnPageNavParent: true
			});
			this.setArrowButtonsVisibility();
		} else {
			// on page nav is an accordion on mobile.
			this.addEventListener(this.element, 'click.mobileNav', ({ target }) => {
				if (target.tagName === 'A') {
					this.element.querySelector('input').checked = false;
				}
			});
		}

		/* this.currentDirection = 'down';
		this.initialTop = null; */
		this.stickNavigationFlag = this.element.dataset.sticky;
		if (this.stickNavigationFlag === 'true') {
			const settings = this.element.dataset;

			this.themeSettings = {
				backgroundColor: {
					value: settings.stickyBg || settings.defaultBg,
					default: settings.defaultBg
				},
				borderColor: {
					value: settings.stickyBorderColor || settings.defaultBorderColor,
					default: settings.defaultBorderColor
				},
				labelColor: {
					value: settings.stickyLabelColor || settings.defaultLabelColor,
					default: settings.defaultLabelColor
				},
				linkColor: {
					value: settings.stickyLinkColor || settings.defaultlinkColor,
					default: settings.defaultLinkColor
				},
				arrow: {
					value: settings.stickyFill || settings.defaultFill,
					default: settings.defaultFill
				}
			};

			this.subscribe('position/updated', ({ value }) => {
				this.isDesktop && this.applyThemeSettings(this.themeSettings, value);
			});
			this.subscribe('collapse/navigation-mobile', () => {
				const { sessionStorage } = window;
				this.element.querySelector('input').checked = false;
				sessionStorage?.setItem('IsMobileNavigationOpen', 'true');
				document.documentElement.classList.remove('stickyMobileNavOpened');
			});
		}
	}

	initDomCache() {
		this.dom = {};

		// Filter out ref's that embedded in another instance of the same behavior.
		Array.from(this.element.querySelectorAll(`[data-ref^=${this.behaviorName.split(' ')[0]}]`))
			.filter(el => el.closest(`[data-behavior*="${this.behaviorName}"]`) === this.element)
			.forEach(element => {
				const ref = element.getAttribute('data-ref');
				const key = dashCaseToCamelCase(ref).split('__')[1];

				if (key) {
					this.dom[key] = element;
				} else {
					console.error(
						`Element cannot be cached. Reference "${ref}" should have the format "behavior-name__element-name"`
					);
				}
			});
	}

	setWidthsToElements() {
		const mainWidth =
			this.getWidth(this.element.querySelector('.v2-onpagenav__container'), false, false) -
			(this.dom.label ? this.getWidth(this.dom.label, true, true) : 0);
		this.element.querySelector('.v2-item-slider').style.width = mainWidth + 'px';
	}

	getWidth(elem, withPadding, withMargin) {
		const style = window.getComputedStyle(elem);
		let width = elem.offsetWidth || Number.parseFloat(style.width);
		if (!withPadding) {
			width = width - Number.parseFloat(style.paddingLeft) - Number.parseFloat(style.paddingRight);
		}
		if (withMargin) {
			width = width + Number.parseFloat(style.marginLeft) + Number.parseFloat(style.marginRight);
		}
		return width;
	}

	setArrowButtonsVisibility() {
		if (this.itemSlider.isAnySliderVisible()) {
			this.dom.leftArrow.classList.add('v2-item-slider__thumb--active');
			this.dom.rightArrow.classList.add('v2-item-slider__thumb--active');
		} else {
			this.dom.leftArrow.classList.remove('v2-item-slider__thumb--active');
			this.dom.rightArrow.classList.remove('v2-item-slider__thumb--active');
			this.element.querySelector('.v2-item-slider').style.width = '';
		}
	}

	applyThemeSettings(settings, prop) {
		if (settings.backgroundColor[prop]) {
			this.element.style.backgroundColor = settings.backgroundColor[prop];
		}
		if (settings.borderColor[prop]) {
			this.element.style.borderColor = settings.borderColor[prop];
		}
		if (settings.labelColor[prop] && this.dom.label) {
			this.dom.label.style.color = settings.labelColor[prop];
		}
		if (settings.linkColor[prop] && this.dom.linksParent) {
			this.dom.linksParent.style.color = settings.linkColor[prop];
		}
		if (settings.arrow[prop]) {
			if (this.isDesktop) {
				this.dom.leftArrow.querySelector('path').style.fill = settings.arrow[prop];
				this.dom.rightArrow.querySelector('path').style.fill = settings.arrow[prop];
			} else {
				this.dom.arrowBar.querySelector('path').style.fill = settings.arrow[prop];
			}
		}
	}
}
